export default __webpack_public_path__ + "static/media/banner-12h-desktop.99f288f8.jpg";